export default "__VITE_ASSET__0ba2c9e1__"